import { takeLatest, call, put } from "redux-saga/effects";
import {
  FETCH_TOP_ACTIVE_JOBS_REQUEST,
  FETCH_TOP_ACTIVE_JOBS_SUCCESS,
  FETCH_TOP_ACTIVE_JOBS_FAILURE,
} from "../../actionTypes";

import {
  fetchTopActiveJobsSuccess,
  fetchTopActiveJobsFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* fetchActiveJobsData(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/get_active_jobs", action.payload)
    );
    if (response.data.status) {
      yield put(fetchTopActiveJobsSuccess(response.data));
    } else {
      fetchTopActiveJobsFailure(response.data);
    }
  } catch (error) {
    yield put(
      fetchTopActiveJobsFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* fetchTopActiveJobsSaga() {
  yield takeLatest(FETCH_TOP_ACTIVE_JOBS_REQUEST, fetchActiveJobsData);
}
export default fetchTopActiveJobsSaga;
